import { FIAT_CURRENCIES, LOCAL_STORAGE_PREFIX } from 'const';


export function GetStoredLocalCurrencyPreference() {
  let currencyID = localStorage.getItem(LOCAL_STORAGE_PREFIX + 'currency');
  if (isNaN(currencyID)) {
    currencyID = 0;
  } else {
    currencyID = Number(currencyID);
    if (FIAT_CURRENCIES[currencyID] === undefined)
      currencyID = 0;
  }
  return currencyID;
}